/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mSlotMachine.vue?vue&type=template&id=22be3b33&scoped=true"
import script from "./mSlotMachine.vue?vue&type=script&lang=js"
export * from "./mSlotMachine.vue?vue&type=script&lang=js"
import style0 from "./mSlotMachine.vue?vue&type=style&index=0&id=22be3b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be3b33",
  null
  
)

export default component.exports